import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import styled from "styled-components";
import { Stack } from "@mui/material";
import InsightsIcon from "@mui/icons-material/Insights";
import AdvancedInsightsRadioGroupRating from "src/scenes/dashboard/overview-components/advanced-insights-assets/advanced-insights-user-opinion";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -51%)",
    bgcolor: "background.paper",
    borderRadius: 4,
    boxShadow: 24,
    width: "30%",
    maxHeight: "95vh",
};

const HeaderStack = styled(Stack)`
    width: 100%;
    background-color: #5b5b5b;
    padding: 4px 8px 2px 16px;
    border-radius: 14px 14px 0 0;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;

const AiInsightsModal = ({
    id,
    type,
    title,
    body,
    modalOpen,
    setModalOpen,
    index,
    existingReaction,
    thumbsUpsCount,
    thumbsDownsCount,
}) => {
    const handleModalClose = () => setModalOpen("");

    return (
        <div>
            <Modal
                open={modalOpen === `${title}-${index}`}
                onClose={handleModalClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <HeaderStack>
                        <Stack direction="row" alignItems="center" spacing={0.5}>
                            <InsightsIcon />
                            {type}
                        </Stack>
                        <AdvancedInsightsRadioGroupRating
                            id={id}
                            existingReaction={existingReaction}
                            thumbsUpsCount={thumbsUpsCount}
                            thumbsDownsCount={thumbsDownsCount}
                        />
                    </HeaderStack>
                    <Stack m={2}>
                        <p style={{ margin: 0 }}>{title}</p>
                        <p
                            id="modal-modal-description"
                            style={{
                                fontSize: "12px",
                                fontWeight: "200",
                                textAlign: "left",
                            }}
                        >
                            {body}
                        </p>
                    </Stack>
                </Box>
            </Modal>
        </div>
    );
};

export default AiInsightsModal;
